import { Component, OnInit } 									    from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } 	    from '@angular/forms';
import { ErrorStateMatcher } 										from '@angular/material/core';

import { Router, ActivatedRoute } 								    from '@angular/router';
import { first } 												    from 'rxjs/operators';

import { AlertService, StudentService } 					    	from '../_services';
import { Globals}                                                   from '../_helpers';

import { Subject } 													from 'rxjs';
import { Observable,throwError } 									from 'rxjs';
import { NgxSpinnerService }                                        from 'ngx-spinner';


@Component({
  selector: 'app-home',
  templateUrl: './exams-list.component.html'
})


export class ExamlistComponent implements OnInit {

  	loading = false;
    submitted = false;    
    returnUrl: string;
    imagePath : string;
    students = [];
    localData = {};
    examIds = [];
    exams = [];

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private studentService: StudentService,
        private alertService: AlertService,
        private spinner: NgxSpinnerService,
        private globals: Globals
    ) {}

    ngOnInit() {
    	this.localData = JSON.parse(localStorage.getItem('currentUser'));
        this.examIds = JSON.parse(localStorage.getItem('examIds'));

        // get return url from route parameters or default to '/'
        this.returnUrl = '/';

		this.getExamList();
    }

    private getExamList(){
        this.spinner.show();
        this.studentService.getExamsData(this.globals.root_url, this.localData['usercode'], this.localData['id'], this.examIds )
          .pipe(first())
          .subscribe(
            data => {
                if(data.code == 1000){
                    this.exams = data.exams; 
                    sessionStorage.setItem('pkshn_assor_feedback', data.exams[0].feedback);
                }
                else if(data.status == 'COM_TOKEN_ERROR'){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    
                    this.loading = false;
                }
                this.spinner.hide();
            },
            error => {
                this.alertService.error(error);
                this.loading = false;
                this.spinner.hide();
            }
        );
    }

    public homeFn(exam_id,vivaassessor,vivapc, viva_practical){
        localStorage.setItem('activeExam_PS', JSON.stringify({exam_id:exam_id,viva_assessor:vivaassessor, vivapc:vivapc, viva_practical:viva_practical}));        
        this.router.navigateByUrl('/home/'+exam_id+'/'+vivaassessor+'/'+vivapc+'/'+viva_practical);
    }
    public gotoHomeDash()
    {
        var parms = this.globals.getRandUrl('dashboard');
        localStorage.setItem('urlStep', JSON.stringify({set:parms}));
        this.router.navigateByUrl('/dashboard/'+parms);
    }
}
